module.exports = __webpack_public_path__ + "static/media/ao.3e1baa08.svg";